import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ActivityList } from "../../components/activity/activity-list";
import { Icon } from "../../components/shell/icons";

/** Everything that happened in the workspace, newest first — who created, edited, moved, trashed what. */
export const Route = createFileRoute("/_app/activity")({
	component: Activity,
});

function Activity() {
	const { t } = useTranslation("pages");
	return (
		<div className="mx-auto w-full max-w-[52rem] px-[1.5rem] pt-[3rem] pb-[4rem] sm:px-[3rem]">
			<h1 className="flex items-center gap-[0.625rem] font-black text-[2rem] text-ink">
				<Icon name="clock" className="size-[1.75rem] text-muted" />
				{t("activity.workspaceTitle")}
			</h1>
			<p className="mt-[0.25rem] mb-[1.5rem] text-muted">{t("activity.workspaceSubtitle")}</p>
			<ActivityList pageId={null} />
		</div>
	);
}
